import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { stripeReducer } from './stripe.reducer';
import { StripeEffects } from './stripe.effects';
import { PAYMENT_SERVICE_PROVIDER } from '@app/core/infrastructure/payment';

/**
 * Stripe Feature State Module
 * 
 * Manages Stripe subscription, plans, products, and session tracking state.
 * Also provides the platform-aware PaymentService (Stripe or Apple IAP).
 */
@NgModule({
  imports: [
    StoreModule.forFeature('stripe', stripeReducer),
    EffectsModule.forFeature([StripeEffects])
  ],
  providers: [
    PAYMENT_SERVICE_PROVIDER
  ]
})
export class StripeStateModule {}
